import { t as ZepIcon } from "../ZepIcon-DpJgyrAI.mjs";
import { jsx } from "react/jsx-runtime";
// src/components/BoltFill.tsx
const BoltFillIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.31 2.05A1 1 0 0 1 14 3v6h5a1 1 0 0 1 .809 1.588l-8 11A1 1 0 0 1 10 21v-6H5a1 1 0 0 1-.809-1.588l8-11a1 1 0 0 1 1.118-.363Z",
		fill: props.fill || "currentColor"
	})
}));
export { BoltFillIcon };
